export const tripTagTitles = {
  SPONSOR: 'Result.TripTag.Campaign.Label',
  SPEED: 'Result.TripTag.Shortest.Label',
  PRICE: 'Result.TripTag.Cheapest.Label',
  STAY: 'Result.TripTag.LongestStay.Label',
  WEIGHTED: 'Result.TripTag.Weighted.Label',
};
